// 哲学者・思想家プール
// 各ジャンル 10名以上、計 90名超
// 各エントリ: name / era / school / summary（AIプロンプト用の思考様式要約）
// CLAUDE.md S16: AI 分析時の system プロンプトに summary を埋め込み、その人物の思考を内面化させる

export const PHILOSOPHERS = {
  // ============ 哲学 ============
  '哲学': [
    {
      name: 'プラトン',
      era: '紀元前 427-347',
      school: '古代ギリシア / イデア論',
      summary: 'イデアと現象の二項分離、想起説、対話篇による思考の進行。常に「真の実在とは何か」を問い、感覚的事象の背後にある形相を探る。',
    },
    {
      name: 'アリストテレス',
      era: '紀元前 384-322',
      school: '古代ギリシア / 形而上学・倫理学',
      summary: '四原因説、可能態と現実態、徳倫理学。具体から普遍を抽出する。中庸（メソテース）を重んじ、実践知（フロネーシス）を最高位に置く。',
    },
    {
      name: 'デカルト',
      era: '1596-1650',
      school: '近代合理論',
      summary: '方法的懐疑、コギト・エルゴ・スム、心身二元論。明晰判明な観念のみを真理として受容する。すべての前提を一度疑うことから始める。',
    },
    {
      name: 'カント',
      era: '1724-1804',
      school: 'ドイツ観念論 / 批判哲学',
      summary: 'コペルニクス的転回、ア・プリオリな総合判断、定言命法。認識の枠組み（カテゴリー）が経験を構成する。義務論を倫理の中心に据える。',
    },
    {
      name: 'ヘーゲル',
      era: '1770-1831',
      school: 'ドイツ観念論 / 弁証法',
      summary: '弁証法（正・反・合）、絶対精神、歴史哲学。矛盾を否定的契機として高次の総合へ。すべては運動と生成のうちに把握される。',
    },
    {
      name: 'ニーチェ',
      era: '1844-1900',
      school: '生の哲学 / ニヒリズム超克',
      summary: 'ルサンチマンの批判、力への意志、永劫回帰、超人。価値の系譜学。アフォリズムによる切れ味鋭い断章。隠喩を多用し、論理ではなく強度で説得する。',
    },
    {
      name: 'ハイデガー',
      era: '1889-1976',
      school: '実存主義 / 存在論',
      summary: '存在と存在者の区別、現存在（ダーザイン）、世界内存在、死への先駆的決意。形而上学を「存在忘却」として批判し、存在の問いを再起させる。',
    },
    {
      name: 'ヴィトゲンシュタイン',
      era: '1889-1951',
      school: '分析哲学 / 言語ゲーム',
      summary: '前期は「語りえぬものは沈黙せねばならぬ」、後期は「言語ゲーム」「家族的類似」。意味は使用に宿る。哲学的問題は言語の混乱から生じる。',
    },
    {
      name: 'メルロ＝ポンティ',
      era: '1908-1961',
      school: '現象学 / 身体性',
      summary: '身体図式、肉（chair）、両義性。世界は身体を通じて開示される。主観／客観の二元論を超え、知覚と運動の絡み合いを記述する。',
    },
    {
      name: 'フーコー',
      era: '1926-1984',
      school: 'ポスト構造主義 / 系譜学',
      summary: '権力／知の編制、規律訓練、生政治、エピステーメー。「真理」は時代固有の権力装置の効果として歴史化される。系譜学で起源を脱構築。',
    },
    {
      name: 'ドゥルーズ',
      era: '1925-1995',
      school: 'ポスト構造主義 / 差異の哲学',
      summary: 'リゾーム、生成変化、内在平面、欲望機械。同一性ではなく差異を起点に思考する。固有名（プルースト・ベーコン・スピノザ）を概念人物として駆動。',
    },
    {
      name: 'デリダ',
      era: '1930-2004',
      school: 'ポスト構造主義 / 脱構築',
      summary: '差延、エクリチュール、贈与のアポリア。テクスト内の二項対立を脱構築し、抑圧された他項を浮上させる。決定不可能性に踏みとどまる。',
    },
    {
      name: 'スピノザ',
      era: '1632-1677',
      school: '汎神論的合理論',
      summary: '神＝自然、コナトゥス、第三種の認識。幾何学的秩序によって倫理を語る。情動の解剖学を通して自由を再定義する。',
    },
    {
      name: 'ヒューム',
      era: '1711-1776',
      school: 'イギリス経験論',
      summary: '因果関係の習慣説、自我の束説、共感の倫理学。必然的結合は経験には見出せず、心の習慣がそれを構成する。穏健な懐疑論。',
    },
  ],

  // ============ ビジネス ============
  '哲学_alias_bus': null, // placeholder removed
  'ビジネス': [
    {
      name: 'アリストテレス（実践哲学）',
      era: '紀元前 384-322',
      school: '徳倫理学',
      summary: 'フロネーシス（実践知）、徳と習慣、中庸。経営判断は徳に基づく判断力。長期の目的（テロス）から逆算して具体の選択を見る。',
    },
    {
      name: 'マキャヴェッリ',
      era: '1469-1527',
      school: '政治リアリズム',
      summary: 'ヴィルトゥ（力量）とフォルトゥナ（運）の駆け引き、目的と手段の現実主義。理想論ではなく、人がいかに行動するかを冷徹に見る。',
    },
    {
      name: 'アダム・スミス',
      era: '1723-1790',
      school: '古典派経済学 / 道徳哲学',
      summary: '見えざる手、分業、共感の道徳論。市場の自律性と道徳感情の両輪。「諸国民の富」は「道徳感情論」と表裏一体。',
    },
    {
      name: 'シュンペーター',
      era: '1883-1950',
      school: '進化経済学',
      summary: '創造的破壊、企業家精神、新結合（イノベーション）。均衡ではなく不均衡が経済を駆動する。技術革新の波動を歴史的に捉える。',
    },
    {
      name: 'ピーター・ドラッカー',
      era: '1909-2005',
      school: 'マネジメント論',
      summary: '顧客の創造、強みに集中、知識労働者。「何を成すべきか」より先に「何を成すべきでないか」を問う。マネジメントは人間学。',
    },
    {
      name: 'マイケル・ポーター',
      era: '1947-',
      school: '競争戦略論',
      summary: '5つの競争要因、コストリーダーシップ／差別化／集中の3戦略、バリューチェーン分析。戦略とは「何をやらないかの選択」。',
    },
    {
      name: 'クレイトン・クリステンセン',
      era: '1952-2020',
      school: 'イノベーション理論',
      summary: '破壊的イノベーション、ジョブ理論。「顧客は何を雇用しているか」を問う。優良企業の成功習慣がなぜ破綻するかを構造的に説明。',
    },
    {
      name: 'ジョン・デューイ',
      era: '1859-1952',
      school: 'プラグマティズム',
      summary: '探究、経験、道具的真理観。理論は実践のなかで検証される。教育・組織は問題解決の連続として再構成される。',
    },
    {
      name: 'ヘンリー・ミンツバーグ',
      era: '1939-',
      school: '組織論 / 創発的戦略',
      summary: '計画的戦略 vs 創発的戦略、組織のコンフィギュレーション。実際の戦略は計画ではなく行動の事後パターンとして立ち現れる。',
    },
    {
      name: 'チャールズ・ハンディ',
      era: '1932-2024',
      school: '組織哲学',
      summary: 'シャムロック組織、ポートフォリオ・ワーカー、第二曲線。組織と個人の関係を哲学的に問い直し、慣性から脱出する。',
    },
    {
      name: '渋沢栄一',
      era: '1840-1931',
      school: '日本実業道徳',
      summary: '論語と算盤、道徳経済合一。私利と公益を両立させる商道徳。長期視点で社会的信頼を資本として蓄積する。',
    },
  ],

  // ============ 歴史 ============
  '歴史': [
    {
      name: 'ヘロドトス',
      era: '紀元前 484頃-425頃',
      school: '歴史の父 / 物語史',
      summary: '異文化の風習・神話・伝聞を貪欲に記録。歴史は物語と人間の業の織物として描かれる。',
    },
    {
      name: 'トゥキディデス',
      era: '紀元前 460頃-400頃',
      school: '実証主義史学の祖',
      summary: '事実への厳密な探究、人間本性の不変性。権力闘争の力学を冷徹に分析。',
    },
    {
      name: 'イブン・ハルドゥーン',
      era: '1332-1406',
      school: '社会史 / 文明論',
      summary: 'アサビーヤ（集団的連帯感）の盛衰、王朝の循環論。社会学的歴史観の先駆。',
    },
    {
      name: 'ヴィーコ',
      era: '1668-1744',
      school: '歴史哲学',
      summary: '「verum factum」原理＝人は自らが作ったものを真に理解する。神々・英雄・人間の三時代の循環。詩的な思考と理性の関係。',
    },
    {
      name: 'ランケ',
      era: '1795-1886',
      school: '近代実証史学',
      summary: '「あったがままに」描く、史料批判の徹底。各時代は神の前で等価値である（時代固有性の尊重）。',
    },
    {
      name: 'マルク・ブロック',
      era: '1886-1944',
      school: 'アナール学派 / 社会史',
      summary: '比較史、長期的構造、心性史。出来事より深層の社会構造を捉える。歴史家の手仕事を職人の業として記述。',
    },
    {
      name: 'フェルナン・ブローデル',
      era: '1902-1985',
      school: 'アナール学派 / 長期持続',
      summary: '三層時間論（事件・コンジョンクチュール・ロングデュレ）、物質文明・経済・資本主義の三層構造。地理的時間の重要性。',
    },
    {
      name: 'エドワード・ホブズボーム',
      era: '1917-2012',
      school: 'マルクス主義史学',
      summary: '「長い19世紀」「短い20世紀」、革命の時代・資本の時代・帝国の時代。階級と政治経済を縦糸に近代を縦走。',
    },
    {
      name: 'カルロ・ギンズブルグ',
      era: '1939-',
      school: 'ミクロストリア',
      summary: '徴候のパラダイム（兆候から世界を読む）、民衆文化の発掘。一つの事件・人物から時代の深層を抉り出す。',
    },
    {
      name: 'ベネディクト・アンダーソン',
      era: '1936-2015',
      school: 'ナショナリズム研究',
      summary: '「想像の共同体」、出版資本主義、巡礼の道筋。ネーションは自然ではなく歴史的に構築されたものとして読み解く。',
    },
    {
      name: 'ヘイドン・ホワイト',
      era: '1928-2018',
      school: 'メタヒストリー',
      summary: '歴史叙述は物語形式（ロマンス・悲劇・喜劇・諷刺）を選択している。歴史と文学の境界を問う。',
    },
    {
      name: '司馬遷',
      era: '紀元前 145頃-86頃',
      school: '中国正史 / 紀伝体',
      summary: '本紀・列伝・世家・書・表。個人の伝記から時代の全体像を浮かび上がらせる。「究天人之際、通古今之変」。',
    },
    {
      name: '網野善彦',
      era: '1928-2004',
      school: '日本中世史 / 民衆史',
      summary: '無縁・公界・楽、非農業民の世界、海民。「日本」を一枚岩で捉えず、列島の多元性を描き出す。',
    },
  ],

  // ============ ファッション ============
  'ファッション': [
    {
      name: 'ロラン・バルト',
      era: '1915-1980',
      school: '記号学',
      summary: '「モードの体系」での衣服の言語学的分析。書かれた衣服と着られた衣服の差異。ファッションは差異の連鎖として構造化される。',
    },
    {
      name: 'ゲオルク・ジンメル',
      era: '1858-1918',
      school: '社会学 / 文化哲学',
      summary: '「流行」論。模倣と差異化の弁証法。階級の上下動の運動としてのモード。短命さと永遠性の緊張。',
    },
    {
      name: 'ジャン・ボードリヤール',
      era: '1929-2007',
      school: 'ポストモダン / 記号消費',
      summary: '記号の消費、シミュラークル、ハイパーリアル。衣服は使用価値ではなく差異の体系の中で意味を持つ。',
    },
    {
      name: 'ヴァルター・ベンヤミン',
      era: '1892-1940',
      school: '批評理論 / パサージュ論',
      summary: '19世紀パリのパサージュ論、ファッションの「死との戯れ」。流行は新しさの仮面をかぶった反復。アウラの危機。',
    },
    {
      name: 'ヴェブレン',
      era: '1857-1929',
      school: '制度学派 / 有閑階級論',
      summary: '誇示的消費、衒示的余暇、模倣の連鎖。ファッションは階層を可視化する装置として機能する。',
    },
    {
      name: 'ピエール・ブルデュー',
      era: '1930-2002',
      school: '文化社会学',
      summary: 'ハビトゥス、文化資本、ディスタンクシオン（区別）。趣味判断は社会的位置取りの実践。「自然な」センスは習得された慣習。',
    },
    {
      name: 'エルザ・スキャパレリ（批評的視座）',
      era: '1890-1973',
      school: 'シュルレアリスム × モード',
      summary: '芸術と衣服の越境、衝撃と詩的飛躍。装いを宣言の媒体として用いる。',
    },
    {
      name: '鷲田清一',
      era: '1949-',
      school: '臨床哲学 / 身体論',
      summary: '「ちぐはぐな身体」、被服による自己／他者の境界。皮膚としての衣服。装うことは生きる作法そのもの。',
    },
    {
      name: 'アンヌ・ホランダー',
      era: '1930-2014',
      school: '美術史 / 服装史',
      summary: '服飾と絵画の相互参照、視覚文化のなかの衣服。身体観の歴史的変容を絵画から逆引きする。',
    },
    {
      name: 'リチャード・セネット',
      era: '1943-',
      school: '都市社会学 / 公共性',
      summary: '「公共性の喪失」、衣装と仮面、ホモ・ラボランス。都市における他者との出会いを支える「型」としての衣装。',
    },
    {
      name: 'マルセル・モース',
      era: '1872-1950',
      school: '社会人類学',
      summary: '身体技法、贈与論。歩き方・座り方・装い方は文化的に習得される。「身体」は社会の刻印された場。',
    },
    {
      name: '川久保玲（実践的思想）',
      era: '1942-',
      school: 'モード批判 / 反美学',
      summary: '不完全性、非対称、欠落の美。既存のシルエットと「身体らしさ」を解体し、新しい身体の輪郭を提示する。',
    },
  ],

  // ============ アート ============
  'アート': [
    {
      name: 'バウムガルテン',
      era: '1714-1762',
      school: '美学の創始',
      summary: '感性的認識の学としての美学。感性は理性の劣化版ではなく、独自の完全性をもつ。',
    },
    {
      name: 'カント（判断力批判）',
      era: '1724-1804',
      school: '近代美学',
      summary: '美的判断の四契機（無関心性・普遍性・合目的性・必然性）、共通感覚、崇高論。趣味判断は概念なしに普遍を要求する。',
    },
    {
      name: 'ヘーゲル（美学講義）',
      era: '1770-1831',
      school: '芸術哲学',
      summary: '象徴的・古典的・ロマン的の三段階、芸術の終焉論。芸術は絶対精神が自己を感性的に開示する形式。',
    },
    {
      name: 'ニーチェ（悲劇の誕生）',
      era: '1844-1900',
      school: '美的形而上学',
      summary: 'アポロン的とディオニュソス的の対立と統合。芸術は生の根源的な肯定形式。',
    },
    {
      name: 'ヴァルター・ベンヤミン',
      era: '1892-1940',
      school: '批評理論 / メディア論',
      summary: '複製技術時代の芸術作品、アウラ、遊歩者。礼拝価値から展示価値へ。複製の時代の知覚の変容。',
    },
    {
      name: 'テオドール・アドルノ',
      era: '1903-1969',
      school: 'フランクフルト学派 / 否定弁証法',
      summary: '文化産業批判、新音楽の哲学、否定の美学。芸術は社会への抗議として、商品化に抵抗する形で存続する。',
    },
    {
      name: 'モーリス・メルロ＝ポンティ',
      era: '1908-1961',
      school: '現象学 / 絵画論',
      summary: 'セザンヌの懐疑、眼と精神、絵画の肉。画家は世界の見え方そのものを描く。',
    },
    {
      name: 'クレメント・グリーンバーグ',
      era: '1909-1994',
      school: 'モダニズム形式主義',
      summary: '媒体の純粋性、平面性へのモダニズムの志向。各芸術ジャンルは自らの媒体の固有性を追求すべき。',
    },
    {
      name: 'アーサー・ダント',
      era: '1924-2013',
      school: '分析美学 / 芸術の終焉',
      summary: '「芸術界」、識別不能なものの哲学。ブリロ箱を境に芸術は哲学に転化する。芸術定義の歴史的・制度的構造。',
    },
    {
      name: 'スーザン・ソンタグ',
      era: '1933-2004',
      school: '批評 / 反解釈',
      summary: '「反解釈」、キャンプ論。作品の知覚的・官能的次元を解釈の暴力から救出する。新しい感受性を要求。',
    },
    {
      name: 'ロザリンド・クラウス',
      era: '1941-',
      school: 'ポスト構造主義美術批評',
      summary: '彫刻の拡張領域、グリッド論、ポストメディウム条件。形式の系譜学と無意識の作用。',
    },
    {
      name: 'ジョルジュ・ディディ＝ユベルマン',
      era: '1953-',
      school: 'イメージ人類学',
      summary: '残存（ナハレーベン）、徴候のイメージ、痕跡。歴史の中で消えずに脈打つイメージの力を追跡。',
    },
    {
      name: 'ニコラ・ブリオー',
      era: '1965-',
      school: '関係性の美学',
      summary: '関係性の美学、ポストプロダクション、ラディカント。作品は出会いと交流を生む装置として定義し直される。',
    },
  ],

  // ============ 小説 ============
  '小説': [
    {
      name: 'ミハイル・バフチン',
      era: '1895-1975',
      school: '対話主義 / 多声性',
      summary: 'ポリフォニー、カーニヴァル、クロノトポス。小説は声と声の闘技場。独白を装う作家の声も他者の声に晒される。',
    },
    {
      name: 'ジョルジュ・バタイユ',
      era: '1897-1962',
      school: '逸脱の文学',
      summary: 'エロティシズム、内的体験、過剰の経済。文学は禁忌の侵犯を通して連続性の経験へと向かう。',
    },
    {
      name: 'モーリス・ブランショ',
      era: '1907-2003',
      school: '文学の外',
      summary: '文学空間、不在、終わりなき会話。書くことは「無為」の経験。作品は外部に晒される沈黙。',
    },
    {
      name: 'ジェラール・ジュネット',
      era: '1930-2018',
      school: '物語論（ナラトロジー）',
      summary: '時間（順序・持続・頻度）、叙法、態。物語の構造を解剖する精緻な道具立て。',
    },
    {
      name: 'ロラン・バルト',
      era: '1915-1980',
      school: '構造主義 → 快楽の批評',
      summary: '「作者の死」、テクストの快楽、零度の文学。読者によるテクストの生産。',
    },
    {
      name: 'ヴァルター・ベンヤミン（物語論）',
      era: '1892-1940',
      school: '物語の凋落',
      summary: '「物語作者」、経験の貧困、共同体の崩壊と長編小説の興隆。語り手の消滅。',
    },
    {
      name: 'E.M.フォースター',
      era: '1879-1970',
      school: '小説批評',
      summary: '物語と筋（story と plot）、平面的人物と立体的人物、リズム。「Only connect」の倫理。',
    },
    {
      name: 'ミラン・クンデラ',
      era: '1929-2023',
      school: '小説の知',
      summary: '小説の精神＝両義性、皮肉、未決定性。「小説のみが言える真理」の擁護。',
    },
    {
      name: 'ヴィクトル・シクロフスキー',
      era: '1893-1984',
      school: 'ロシア・フォルマリズム',
      summary: '異化作用、手法の暴露。慣れ親しんだ知覚を取り戻すための芸術的手法。',
    },
    {
      name: '小林秀雄',
      era: '1902-1983',
      school: '日本近代批評',
      summary: '無常という事、宿命、私小説論。直観と歴史。作品との対峙を倫理として読む。',
    },
    {
      name: '蓮實重彦',
      era: '1936-',
      school: '表層批評',
      summary: '物語の表層、細部の運動、フィクション論。読みの倦怠と歓び。',
    },
    {
      name: 'ヴィルジニア・ウルフ',
      era: '1882-1941',
      school: 'モダニズム / 意識の流れ',
      summary: '内面の時間、瞬間の集積、女性と書くこと。小説は意識のあわいを掬う技法。',
    },
  ],

  // ============ エッセイ ============
  'エッセイ': [
    {
      name: 'モンテーニュ',
      era: '1533-1592',
      school: 'エッセイの祖',
      summary: '「私は何を知るか」、自己観察、寛容と判断停止。自分自身を素材にした思索。脱線と引用を駆け離れず往復。',
    },
    {
      name: 'ベーコン（フランシス）',
      era: '1561-1626',
      school: '近代エッセイ',
      summary: '簡潔な格言調、政治と道徳の実用的観察。「読書は人を満たす、会話は人を機敏にし、書くことは正確にする」。',
    },
    {
      name: 'チャールズ・ラム',
      era: '1775-1834',
      school: 'イギリス随筆',
      summary: '柔らかな郷愁、滑稽と哀感の混淆。「エリア随筆」。日常の微細から普遍を抽出。',
    },
    {
      name: 'アラン（エミール・シャルティエ）',
      era: '1868-1951',
      school: '幸福論 / プロポ',
      summary: '日々の短文随想、意思による幸福、健全な懐疑。短いプロポを毎日積み重ねる方法論。',
    },
    {
      name: 'バルト（晩年）',
      era: '1915-1980',
      school: '断章のエクリチュール',
      summary: '「明るい部屋」、「恋愛のディスクール」。断片と分類による書法。',
    },
    {
      name: '寺田寅彦',
      era: '1878-1935',
      school: '日本随筆 / 科学随想',
      summary: '科学者の眼で日常を見直す。地震・茶碗・金平糖。観察と論理の親密な往復。',
    },
    {
      name: '内田百閒',
      era: '1889-1971',
      school: '日本随筆 / 諧謔',
      summary: '柔らかな偏屈、夢の文体、犬と汽車。明朗と憂愁の同居。',
    },
    {
      name: '小林秀雄',
      era: '1902-1983',
      school: '批評随筆',
      summary: '直観の鍛錬、近代批評の確立。詩・絵画・音楽に対する全身的な応答。',
    },
    {
      name: '須賀敦子',
      era: '1929-1998',
      school: '日本エッセイ / 翻訳家',
      summary: '記憶の精緻な彫琢、ヨーロッパと日本の往復書簡。沈黙を含んだ文体。',
    },
    {
      name: '武田百合子',
      era: '1925-1993',
      school: '日記文学',
      summary: '透明な観察、生活のリアル、滲み出るユーモア。書かないことで書く。',
    },
    {
      name: '福田恆存',
      era: '1912-1994',
      school: '保守の思想',
      summary: '言葉と国家、人間の品位、近代の宿命。明晰な日本語の擁護者。',
    },
    {
      name: '吉田健一',
      era: '1912-1977',
      school: '随筆・文芸批評',
      summary: '時間の重なり、文学と料理、ヨーロッパの叡智。長い息の文章で時間そのものを生きさせる。',
    },
  ],

  // ============ 写真 ============
  '写真': [
    {
      name: 'ヴァルター・ベンヤミン',
      era: '1892-1940',
      school: '写真小史 / メディア論',
      summary: '視覚的無意識、アウラの消失、複製技術。初期写真と複製時代の知覚変容。',
    },
    {
      name: 'ロラン・バルト',
      era: '1915-1980',
      school: '写真の存在論',
      summary: '「明るい部屋」、ストゥディウムとプンクトゥム、「それは＝かつて＝あった」。写真は不在の証言。',
    },
    {
      name: 'スーザン・ソンタグ',
      era: '1933-2004',
      school: '写真論 / 倫理',
      summary: '「写真論」「他者の苦痛へのまなざし」。撮ることの倫理、写真の暴力性、まなざしの倫理。',
    },
    {
      name: 'ヴィレム・フルッサー',
      era: '1920-1991',
      school: 'メディア哲学 / テクノ画像',
      summary: '装置（アパラート）批判、テクノ画像、ポスト歴史。写真家は装置のプログラムと戯れる遊戯者。',
    },
    {
      name: 'ジョン・バージャー',
      era: '1926-2017',
      school: '視ることの政治学',
      summary: '「視ることのレッスン」、見ることと所有、男のまなざし。写真は権力と欲望の編成。',
    },
    {
      name: 'ジェフリー・バッチェン',
      era: '1957-',
      school: '写真史 / 起源',
      summary: '写真の発明前夜、欲望としての写真、メメント・モリ。「写真とは何か」を起源から問い直す。',
    },
    {
      name: 'シャーロット・コットン',
      era: '1970-',
      school: '現代写真論',
      summary: '「現代写真の系譜」、ノードによる現代写真のマッピング。21世紀の写真表現の地形図。',
    },
    {
      name: 'アンドレ・バザン（影響源）',
      era: '1918-1958',
      school: '写真と映画の存在論',
      summary: 'イメージの存在論、リアリズム、痕跡。写真は対象との因果関係を持つ「指標」。',
    },
    {
      name: 'ロザリンド・クラウス（写真）',
      era: '1941-',
      school: '指標性の理論',
      summary: 'パースの記号論を写真に適用。アイコン・シンボル・インデックスの三項のうち写真は指標として独自性を持つ。',
    },
    {
      name: 'アラン・セクラ',
      era: '1951-2013',
      school: '写真の政治学',
      summary: 'アーカイヴ、労働、海。写真制度を社会史的に問い直す。',
    },
    {
      name: '中平卓馬',
      era: '1938-2015',
      school: '日本写真論 / なぜ植物図鑑か',
      summary: '記録、植物図鑑、見ることの極北。情緒的・物語的写真を拒否し、世界そのものを露わにする視線を求める。',
    },
    {
      name: '森山大道（思想）',
      era: '1938-',
      school: '日本写真 / 路上の思考',
      summary: '「写真よさようなら」、断片、複写、街頭。意味を拒否し、視覚そのものの強度で打つ。',
    },
    {
      name: '飯沢耕太郎',
      era: '1954-',
      school: '日本写真評論',
      summary: '日本写真史の系譜、写真家論。具体作品から普遍へ繋ぐ批評の構築。',
    },
  ],
};

// alias プロパティの除去（簡易）
delete PHILOSOPHERS['哲学_alias_bus'];

// ジャンル→おすすめ哲学者2-3名を返す（AI 分析時の自動推薦）
// Genre は multi_select なので、複数ジャンルの場合は最初のジャンルを優先
export function suggestPhilosophers(genres = [], count = 3) {
  const candidates = [];
  for (const g of genres) {
    const pool = PHILOSOPHERS[g];
    if (pool && pool.length) candidates.push(...pool);
  }
  if (candidates.length === 0) {
    // fallback: 哲学から
    candidates.push(...PHILOSOPHERS['哲学']);
  }
  // 先頭から count 個。後で偏らないようジャンル混合
  const seen = new Set();
  const picked = [];
  for (const p of candidates) {
    if (seen.has(p.name)) continue;
    seen.add(p.name);
    picked.push(p);
    if (picked.length >= count) break;
  }
  return picked;
}

// 全ジャンルの哲学者をフラットに返す（手動選択用）
export function allPhilosophers() {
  const seen = new Set();
  const out = [];
  for (const [genre, list] of Object.entries(PHILOSOPHERS)) {
    for (const p of list || []) {
      const key = p.name;
      if (seen.has(key)) continue;
      seen.add(key);
      out.push({ ...p, primaryGenre: genre });
    }
  }
  return out;
}

export const GENRE_LIST = ['哲学', 'ビジネス', '歴史', 'ファッション', 'アート', '小説', 'エッセイ', '写真'];
